// Implements: F-MCK-021
/**
 * The signed-in person's id, read from the session's cached answer (`SESSION_SCOPES_KEY`) without
 * requiring a `SessionProvider`, or `null` when no session was read. Mockup v3 P4 uses it to tell
 * "you" from somebody else in the transfer notice and the people tab.
 */

import { useQueryClient } from "@tanstack/react-query";

import type { ScopesView } from "../../types/api";
import { SESSION_SCOPES_KEY } from "./queryKeys";

export function useViewerId(): string | null {
  return useQueryClient().getQueryData<ScopesView | null>(SESSION_SCOPES_KEY)?.user.id ?? null;
}
